var _rect, _path, _path2, _circle, _circle2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6437 29.0762L48.7164 29.637L45.9926 59.9199H23L25.6437 29.0762Z",
    fill: "#F3CB64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1224 29.4766L56.1667 59.9998H45.752L48.636 29.7169L53.1224 29.4766Z",
    fill: "#D68D20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.955,
    cy: 32.2719,
    r: 0.995006,
    fill: "#AC6E11"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.9052,
    cy: 32.2719,
    r: 0.995006,
    fill: "#AC6E11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7276 32.2233L41.7276 35.8055C41.5286 37.4377 39.9801 40.5796 35.3772 40.09C33.9019 39.8619 31.8171 38.655 31.6937 34.9449L31.6934 31.9426",
    stroke: "#D68D20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6133,
    y: 20.1558,
    width: 1.32667,
    height: 3.31669,
    transform: "rotate(-6.73601 33.6133 20.1558)",
    fill: "#EAA238"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32667,
    height: 3.31669,
    transform: "matrix(-0.993097 -0.117295 -0.117295 0.993097 46.5967 20.1558)",
    fill: "#EAA238"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32667,
    height: 3.31669,
    transform: "matrix(-0.645426 -0.763823 -0.763823 0.645426 52.9233 24.3301)",
    fill: "#EAA238"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32667,
    height: 3.31669,
    transform: "matrix(-0.993097 -0.117295 -0.117295 0.993097 41.29 20.1558)",
    fill: "#EAA238"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32667,
    height: 3.31669,
    transform: "matrix(-0.630922 0.775847 0.775847 0.630922 28.4805 23.3169)",
    fill: "#EAA238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBag);
export default __webpack_public_path__ + "static/media/open-bag.82a502d5ee7d47f9bf62efddd67c444d.svg";
export { ForwardRef as ReactComponent };